import { useBehavior } from '@libs/core';
import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { TCoreLayoutOptions } from '../types/options';
import { CoreLayoutView } from './CoreLayoutView';

/**
 * Standalone layout widget driven entirely by server-provided configuration.
 * Owns behavior hooks (useBehavior) and delegates rendering to CoreLayoutView.
 *
 * Use this component when the widget definition comes from the server and no
 * additional style overrides are required.
 */
const CoreLayoutWidget = ({ widget, children }: React.PropsWithChildren<TWidgetProps<TCommonData, TCoreLayoutOptions>>) => {
    const { isHidden } = useBehavior(widget);

    return (
        <CoreLayoutView widget={widget} isHide={isHidden} styleName={widget.options?.style}>
            {children}
        </CoreLayoutView>
    );
};

export { CoreLayoutWidget };
